import React, { ElementType } from 'react';
import { DateTime } from 'luxon';
import { Typography, TypographyProps } from '@mui/material';
import { DATE_FORMAT, TIME_FORMAT } from '../constants/date';

interface DateTimeProps extends TypographyProps {
  component?: ElementType;
  value: string | number | null | undefined;
  timeOnly?: boolean;
  dateOnly?: boolean;
  utcToLocal?: boolean;
}

export function dateTimeFormat(value?: string, format: string = 'F', utcToLocal: boolean = false): string {
  if (!value) return '';
  return utcToLocal
    ? DateTime.fromISO(`${value}`).toLocal().toFormat(format)
    : DateTime.fromISO(value, { zone: 'utc' }).toFormat(format);
}

function getFormat(timeOnly: boolean = false, dateOnly: boolean = false): string {
  if (timeOnly) return TIME_FORMAT;
  if (dateOnly) return DATE_FORMAT;
  return [DATE_FORMAT, TIME_FORMAT].join(' ');
}

const ViewDateTime: React.FC<DateTimeProps> = (props) => {
  const { timeOnly, dateOnly, utcToLocal, ...typographyProps } = props;
  let value = props.value;
  if (!value) {
    return null;
  }

  if (typeof value === 'number') {
    value = new Date(value).toISOString();
  }

  const format = getFormat(timeOnly, dateOnly);
  const date = dateTimeFormat(value, format, utcToLocal);

  return <Typography {...typographyProps}>{date}</Typography>;
};

export default ViewDateTime;
